import React from "react"
import { graphql, StaticQuery } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import SEO from "../components/seo"

import "../utils/normalize.css"
import "../utils/css/screen.css"

const AboutPage = ({ data }, location) => {
  const siteTitle = data.site.siteMetadata.title

  return (
    <Layout title={siteTitle}>
      <SEO
        title="About"
        keywords={[
          `Parametric`,
          `Wall Sculpture`,
          `Contemporary Art`,
          `Dimensional Wall Art`,
          `3D Wall Art`,
          `Modern Art`,
          `Flower Art`,
          `Mosaic Art`,
          `Wood Wall Art`,
          `Sacred Geometry`,
          `Abstract Art`,
          `Wall Object`,
          `3D Printing`,
          `Mandala Art`,
          `Geometric Art`,
          `Trippy Art`,
        ]}
      />


      <article className="post-content page-template no-image">
        <div className="post-content-body">
          {/* <h2 id="clean-minimal-and-deeply-customisable-london-is-a-theme-made-for-people-who-appreciate-simple-lines-">
          Fusing Organic Forms with Digital Precision
          </h2> */}
          {/* <figure className="kg-card kg-image-card kg-width-wide"> */}

          
            <GatsbyImage
              image={data.benchAccounting.childImageSharp.gatsbyImageData}
              className="kg-image"
            />
            {/* <figcaption>Assembling "Pine Stone" Six Petal Sculpture</figcaption>
          </figure> */}
          <h3 id="dynamic-styles">Biomorphic Tessellations Giving Rise to Emergent Form</h3>

          <p>Herschel Shapiro works in the style of Organic Precision, exploring how repeating, life-inspired modules can combine into singular sculptural experiences. His pieces draw on the subtle rhythms of nature—spirals, waves, cellular arrays—yet reveal a clarity of form that feels both familiar and surprising.</p>

          <p>Central to his practice is the careful assembly of small, organic shapes into larger patterns. Each element contributes to a cohesive whole, allowing intricate structures to emerge naturally rather than being imposed stroke by stroke. The result is a harmony of parts that transcends their individual lines and curves.</p>

          <p>Herschel’s sculptures invite you to linger and discover: a petal-like relief here, a shifting angle there, each detail resonating with a sense of growth and balance. The interplay of repetition and variation creates compositions that feel alive—never static, always unfolding in the viewer’s gaze.</p>

          <p>Whether carved from solid wood, cast in resin, or finished with subtle pigments, every work carries a palpable presence. The materials themselves speak to durability and tactility, encouraging a direct, sensory engagement rather than mere observation.</p>

          <p>Through Organic Precision, Herschel Shapiro reveals how simple geometric rhythms can give rise to complex, living forms—sculptures that bridge the gap between structure and flow, inviting a deeper appreciation of the patterns that shape our world.</p>
        </div>
      </article>
    </Layout>
  )
}

const indexQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    benchAccounting: file(relativePath: { eq: "herschel.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 1360)
      }
    }
  }
`

export default props => (
  <StaticQuery
    query={indexQuery}
    render={data => (
      <AboutPage location={props.location} data={data} {...props} />
    )}
  />
)
